/**
 * Bundle-split predicate: is this pathname served by the /lazecast landing
 * bootstrap branch (see src/main.tsx)?
 *
 * The landing (future default UI) must boot WITHOUT the heavy main-app payload
 * (app shell, v1/v2 screens, react-router, the app's locale registry). main.tsx
 * branches on this predicate BEFORE importing either tree, so the two bundles
 * stay on separate lazy graphs — including M33's pre-mount locale preload, which
 * the landing skips because it owns a separate dict path.
 *
 * Matches "/lazecast" and anything under "/lazecast/…" (mirrors the router's
 * old `/lazecast/*` route — offline/SW-served subpaths included). Does NOT
 * match lookalikes ("/lazecastx") or the SSR-only pages by other prefixes.
 */
export function isLandingPath(pathname: string): boolean {
  return pathname === "/lazecast" || pathname.startsWith("/lazecast/");
}

/**
 * RAW locale segment of a localized landing entry (/lazecast/{locale}), or
 * null. Deliberately registry-free (this module must stay dependency-light —
 * see the header): the caller validates the segment against the locale
 * registry (isLocale) before using it.
 */
export function landingPathLocale(pathname: string): string | null {
  const m = /^\/lazecast\/([A-Za-z]{2,3}(?:-[A-Za-z]{2,4})?)\/?$/.exec(pathname);
  return m ? m[1]! : null;
}
